export default "__VITE_ASSET__a4694165__"